'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducers = exports.sizeReducer = exports.widthReducer = exports.heightReducer = exports.defaultState = undefined;

var _eq2 = require('lodash/eq');

var _eq3 = _interopRequireDefault(_eq2);

var _constant2 = require('lodash/constant');

var _constant3 = _interopRequireDefault(_constant2);

var _reducers;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setDimension = setDimension;

var _capeRedux = require('cape-redux');

var _capeLodash = require('cape-lodash');

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = exports.defaultState = {
  height: null,
  heightMax: null,
  id: null,
  rem: null,
  width: null,
  widthMax: null
};
function setDimension(id) {
  var maxKey = id + 'Max';
  return function (state, payload) {
    var _extends2;

    if ((0, _eq3.default)(state[id], payload)) return state;
    return _extends({}, state, (_extends2 = {}, _defineProperty(_extends2, id, payload), _defineProperty(_extends2, maxKey, Math.max(state[maxKey] || 0, payload)), _extends2));
  };
}
var heightReducer = exports.heightReducer = setDimension('height');
var widthReducer = exports.widthReducer = setDimension('width');
var sizeReducer = exports.sizeReducer = function sizeReducer(state, _ref) {
  var width = _ref.width,
      height = _ref.height;
  return heightReducer(widthReducer(state, width), height);
};

var reducers = exports.reducers = (_reducers = {}, _defineProperty(_reducers, _actions.SET_HEIGHT, heightReducer), _defineProperty(_reducers, _actions.SET_ID, (0, _capeLodash.setKey)('id')), _defineProperty(_reducers, _actions.SET_REM, (0, _capeLodash.setKey)('rem')), _defineProperty(_reducers, _actions.SET_SIZE, sizeReducer), _defineProperty(_reducers, _actions.SET_WIDTH, widthReducer), _defineProperty(_reducers, _actions.RESET, (0, _constant3.default)(defaultState)), _reducers);
exports.default = (0, _capeRedux.createReducer)(reducers, defaultState);


//////////////////
// WEBPACK FOOTER
// ./~/redux-windowsize/lib/reducer.js
// module id = 1276
// module chunks = 0